/**
 * @generated SignedSource<<981fa78d688e8b1ea0254ab8f14e4cfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventGuestAssessmentResponsesFragment$data = {
  readonly GAD: ReadonlyArray<{
    readonly id: string;
    readonly questionId: string;
    readonly questionResponse: number;
  }> | null;
  readonly PHQ: ReadonlyArray<{
    readonly id: string;
    readonly questionId: string;
    readonly questionResponse: number;
  }> | null;
  readonly Workplace: ReadonlyArray<{
    readonly id: string;
    readonly questionId: string;
    readonly questionResponse: number;
  }> | null;
  readonly submittedAt: any | null;
  readonly " $fragmentType": "eventGuestAssessmentResponsesFragment";
};
export type eventGuestAssessmentResponsesFragment$key = {
  readonly " $data"?: eventGuestAssessmentResponsesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventGuestAssessmentResponsesFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionResponse",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eventGuestAssessmentResponsesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventGuestAssessmentResponse",
      "kind": "LinkedField",
      "name": "GAD",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventGuestAssessmentResponse",
      "kind": "LinkedField",
      "name": "PHQ",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventGuestAssessmentResponse",
      "kind": "LinkedField",
      "name": "Workplace",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submittedAt",
      "storageKey": null
    }
  ],
  "type": "EventGuestAssessmentResponses",
  "abstractKey": null
};
})();

(node as any).hash = "7955dc1bdbe8a825defc19a01dedc4d5";

export default node;
